import { useQuery } from "react-query";
import axios from "infra/http";
import { ContaDetalheResponse } from "../typings";
import moment from "moment";

function useFindConta(id: string | undefined) {
  return useQuery(
    `/v1/conta/${id}`,
    async () => {
      const { data } = await axios.get<ContaDetalheResponse>(`/v1/conta/${id}`);

      if (data.dataCompetencia) {
        data.dataCompetencia = moment(data.dataCompetencia)
          .startOf("day")
          .format("YYYY-MM");
      }

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useFindConta;
